export const COLORS = [
  'var(--bg-red-20)',
  'var(--bg-orange-20)',
  'rgba(255, 214, 0, 0.2)',
  'var(--bg-wave-20)',
  'var(--bg-green-20)',
];
export const COLORS_HOVER = [
  'var(--bg-error)',
  'var(--bg-warning)',
  'rgba(255, 214, 0)',
  'var(--bg-wave)',
  'var(--bg-green)',
];
